export const SEARCH_MOVIE       = 'SEARCH_MOVIE';
export const FETCH_MOVIES       = 'FETCH_MOVIES';
export const FETCH_MOVIE        = 'FETCH_MOVIE';
export const LAST_MOVIE         = 'LAST_MOVIE';
export const NOW_PLAYING_MOVIE  = 'NOW_PLAYING_MOVIE';
export const TOP_RATED_MOVIES   = 'TOP_RATED_MOVIES';
export const POPULAR_MOVIES     = 'POPULAR_MOVIES';